import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import GetAppIcon from '@mui/icons-material/GetApp';
import DescriptionIcon from '@mui/icons-material/Description';
import TableChartIcon from '@mui/icons-material/TableChart'; 
import SlideshowIcon from '@mui/icons-material/Slideshow';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';

import { AudioMessage } from '../../chat/Messages/AudioMessage';
export const ImageMessage = ({ message }) => {
    const [open, setOpen] = useState(false);

    const getExtension = (filename) => {
        const parts = filename?.split('.') || [];
        return parts.length > 1 ? parts.pop().toLowerCase() : '';
    };

    const ext = getExtension(message?.name);
    const isImage = message.type === 'image';
    const isVideo = message.type === 'video';
    const isAudio = message.type === 'audio';
    const isDoc = message.type === 'document';

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = message.text || message.url;
        link.download = message.name || 'file';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const renderDocIcon = () => {
        switch (ext) {
            case 'pdf':
                return <PictureAsPdfIcon sx={{ color: '#e53935' }} />;
            case 'doc':
            case 'docx':
                return <DescriptionIcon sx={{ color: '#2196f3' }} />;
            case 'xls':
            case 'xlsx':
                return <TableChartIcon sx={{ color: '#4caf50' }} />;
            case 'ppt':
            case 'pptx':
                return <SlideshowIcon sx={{ color: '#ff9800' }} />;
            default:
                return <InsertDriveFileIcon sx={{ color: '#64b5f6' }} />;
        }
    };

    return (
        <Box sx={{ position: 'relative', maxWidth: 300 }}>
            {/* Document */}
            {isDoc && (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        padding: 1,
                        backgroundColor: '#2a3942',
                        borderRadius: '10px',
                        color: 'white',
                        cursor: 'pointer',
                    }}
                    onClick={() => window.open(message?.text, '_blank')}
                >
                    {renderDocIcon()}
                    <Typography
                        sx={{
                            fontSize: 14,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {message.name}
                    </Typography>
                </Box>
            )}

            {/* Image */}
            {isImage && (
                <>
                    <img
                        src={message?.url}
                        alt="preview"
                        onClick={() => setOpen(true)}
                        style={{ width: '100%', borderRadius: '10px', cursor: 'pointer' }}
                    />
                    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
                        <img src={message.url} alt="full-size" style={{ width: '100%' }} />
                    </Dialog>
                </>
            )}

            {/* Video */}
            {isVideo && (
                <video
                    controls
                    src={message?.url}
                    style={{ width: '100%', borderRadius: '10px' }}
                />
            )}

            {isAudio && (
                <AudioMessage url={message?.url} /> 
            )}

            <Box
                sx={{
                    position: 'absolute',
                    bottom: 5,
                    right: 5,
                    display: 'flex',
                    alignItems: 'center',
                    ...(!isAudio &&{
                        backgroundColor: 'rgba(0,0,0,0.5)'
                    }),
                    borderRadius: '8px',
                    paddingX: 1,
                    ...(isAudio && {
                        transform: 'translate(5px, 10px)'
                    }) 
                }}
            >
                {!isAudio && !isVideo && (
                    <GetAppIcon
                        onClick={handleDownload}
                        fontSize="small"
                        sx={{ color: 'white', cursor: 'pointer', mr: 1 }}
                    />
                )}
                <Typography 
                    sx={{
                        fontSize: isAudio ? 10 : 11,
                        color: isAudio ? '#919191' : 'white'
                    }}
                >
                    {message.time}
                </Typography>
            </Box>
        </Box>
    );
};
